import React from "react";
import useVendorStatus from "../../../../store/ReactQueries/procurements/vendorStatuses/useVendorStatus";
import Select, { SingleValue } from "react-select";
import { darkModeStepperNav } from "../../../../utils/constants";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { useLanguageStore } from "../../../../store/useLanguageStore";

interface SelectVendorStatusProps {
    label: string;
    vendorStatusId: string;
    viewMode?: boolean;
    handleVendorStatus: (selectedOption: SingleValue<{
        label: any;
        value: string;
    }>) => void;
}

const SelectVendorStatus = ({
    label, vendorStatusId, viewMode = false,
    handleVendorStatus
}: SelectVendorStatusProps) => {
    const { darkMode } = useDarkModeStore();
    const { language } = useLanguageStore()

    const { data: vendorStatuses } = useVendorStatus(0, 0);

    const labelName = vendorStatuses?.find((item: any) => item.id === vendorStatusId)?.title ?? '';

    const renderViewMode = () => {
        return <div className={`d-flex flex-row gap-1 align-items-center ${darkMode && 'text-white'}`}>
            <span style={{ fontSize: 12 }}>{language['VendorStatus']}:</span>
            <span className="fw-bold" style={{ fontSize: 12 }}>{labelName}</span>
        </div>
    }

    const renderEditMode = () => {
        return <div className='w-100 mt-2 position-relative'>
            <label
                className={darkMode ? 'text-white' : 'text-muted'}
                style={{
                    position: 'absolute',
                    top: -7,
                    left: 10,
                    zIndex: 100,
                    fontSize: 12,
                    padding: '0 5px',
                    fontWeight: 'bold',
                    color: darkMode ? 'white' : '#a4a4a4',
                    background: darkMode ? darkModeStepperNav : 'white',
                }}
            >
                {language[label] ?? label}
            </label>
            <Select
                value={{ label: labelName, value: vendorStatusId }}
                className={`${darkMode && "dark-mode-input"}`}
                onChange={handleVendorStatus}
                placeholder="Zgjedh"
                options={vendorStatuses?.map((item: any) => ({
                    value: item.id ?? "",
                    label: item.title ?? '',
                }))}
                styles={{
                    menu: (provided) => ({ ...provided, zIndex: 11 }),
                    container: (provided) => ({
                        ...provided,
                        position: "relative",
                        zIndex: 11,
                    }),
                    singleValue: (provided) => ({
                        ...provided,
                        color: darkMode ? 'white' : 'black',
                    }),
                    menuPortal: (base) => ({ ...base, zIndex: 11 }),
                    control: (provided) => ({
                        ...provided,
                        height: 50,
                        borderColor: darkMode ? '#585858' : "initial",
                        backgroundColor: darkMode ? darkModeStepperNav : "white",
                    }),
                }}
                menuPlacement="top"
                menuPortalTarget={document.body}
            />
        </div>
    }

    return viewMode
        ? renderViewMode()
        : renderEditMode()
}

export default SelectVendorStatus;